
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1ApTJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $91aeb40e25cb918f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $91aeb40e25cb918f$export$2e2bcd8739ae039 = {
    "'Goals.CreateGoal.footer.create-label": 'Create',
    'Goals.CreateGoal.EditMetric.header': 'Edit metric',
    'Goals.CreateGoal.create.error': 'Could not create goal',
    'Goals.CreateGoal.create.network.error': 'Connection failed',
    'Goals.CreateGoal.create.permission.error': "You don't have the required permission to create a goal.",
    'Goals.CreateGoal.error.description': 'Something went wrong, please check your internet connection and try again.',
    'Goals.CreateGoal.error.header': 'Could not create goal',
    'Goals.CreateGoal.footer.cancel-label': 'Cancel',
    'Goals.CreateGoal.form.icon.back-button-label': 'Back',
    'Goals.CreateGoal.form.name.error': 'You must provide a goal name',
    'Goals.CreateGoal.form.name.label': 'Name',
    'Goals.CreateGoal.form.owner.error': "Owner can't be blank.",
    'Goals.CreateGoal.header': 'Create goal',
    'Goals.CreateGoal.parent-goal-label': 'Parent goal',
    'Goals.CreateGoal.parent-goal.error': "Parent goal can't be blank.",
    'Goals.CreateGoal.required-fields-are-marked': 'Required fields are marked with an asterisk <asterisk></asterisk>',
    'Goals.CreateGoal.site-label': 'Site',
    'Goals.CreateGoal.type-label': 'Type',
    'Goals.CreateGoal.type-label-placeholder': 'What should we call this?',
    'Goals.CreateMetric.add-metric-button': 'Add metric',
    'Goals.CreateMetric.metric-select.create-new': 'Create new metric',
    'Goals.CreateMetric.metric-select.use-existing': 'Use existing metric',
    'Goals.CreateMetric.metric-start-value.label': 'Start value',
    'Goals.CreateMetric.metric-target-value.label': 'Target value',
    'Goals.CreateMetric.metric-unit-select.label': 'Unit',
    'Goals.GoalCreationModal.label.date-selection-placeholder': 'Select a date',
    'Goals.GoalCreationModal.label.date-selection-title': 'Target date',
    'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Enter person',
    'Goals.GoalCreationModal.label.owner-selection-title': 'Owner',
    'townsquare.api.goal-type-description.goal': 'All-purpose goals',
    'townsquare.api.goal-type-description.key-result': 'The quantitative way to measure an objective (OKR framework).',
    'townsquare.api.goal-type-description.objective': 'The outcome you want to achieve (OKR framework).'
};

});


//# sourceMappingURL=en_GB.8a36850a.js.map
